<script setup lang="ts">
import { useBreakpoints } from '@fire-calc/ui-vue';
import MobileCalculatorLayout from './MobileCalculatorLayout.vue';
import DesktopCalculatorLayout from './DesktopCalculatorLayout.vue';

const { current } = useBreakpoints();
</script>

<template>
  <MobileCalculatorLayout v-if="current !== 'desktop'" />
  <DesktopCalculatorLayout v-else />
</template>